module.exports = __webpack_public_path__ + "img/EXTERIOR-IGNIS-5.49c998f9.jpg";